export default import.meta.ROLLUP_FILE_URL_mNKpayOSBSr9pkQ0vWrOCQ